// Layout for the helper's own screen (bead hf-e6-commitments-coverage-udt.9).
//
// CSS-only, like every other feature stylesheet here.
//
// THE ONE LAYOUT DECISION THAT IS A PRODUCT DECISION: the support window is the
// largest line on a commitment card, and the appointment beneath it is muted and
// smaller. A need's window is independent of its event's (invariant 5, NED-002), the
// two are routinely different, and this is the screen where reading the wrong one
// makes somebody arrive at the wrong time. Type size is doing the same job the
// "Around …" wording does, so the distinction survives a glance as well as a read.
//
// Nothing here is coloured by urgency. There is no accent on a section that has items
// in it and no muting of one that does not: sections look the same whatever they
// contain, because a screen that visually raised its voice as work accumulated would
// be the pressure mechanic the tone rules forbid, applied through CSS instead of copy.
export const homeStylesheet = `
.my-week { display: grid; gap: var(--space-24, 1.5rem); }
.my-week__heading { margin: 0; }
.my-week__introduction { margin: 0; color: var(--color-ink-muted, #5b6862); }
.my-week__section { display: grid; gap: var(--space-16, 1rem); }

.my-week-commitments { display: grid; gap: var(--space-16, 1rem); }
.my-week-commitments h2 { margin: 0; }
.my-week-commitments__list { display: grid; gap: var(--space-16, 1rem);
  list-style: none; margin: 0; padding: 0; }
/* The hours they agreed to: first, and the biggest thing on the card. */
.my-week-commitments__when { margin: 0; font-weight: 600;
  font-size: var(--font-size-18, 1.125rem); }
/* The appointment: quieter and smaller, so it can only read as context. */
.my-week-commitments__event { margin: var(--space-4, 0.25rem) 0 0;
  font-size: var(--font-size-14, 0.875rem); color: var(--color-ink-muted, #5b6862); }
.my-week-commitments__with { margin: var(--space-4, 0.25rem) 0 0;
  color: var(--color-ink-muted, #5b6862); }
.my-week-commitments__state { margin: var(--space-12, 0.75rem) 0 0; }
.my-week-commitments__link { margin: var(--space-8, 0.5rem) 0 0; }

.my-week-availability { display: grid; gap: var(--space-8, 0.5rem); }
.my-week-availability h2 { margin: 0; }
.my-week-availability__summary { margin: 0; }
.my-week-availability__meaning { margin: 0; color: var(--color-ink-muted, #5b6862); }
/* The renewal prompt is set apart so it is findable, and deliberately uses the same
   sunken surface as every other quiet panel — not a warning tone. Availability
   lapsing is the design working, not a problem somebody has to fix (AVL-019). */
.my-week-availability__renewal { display: grid; gap: var(--space-4, 0.25rem);
  border: 1px solid var(--color-border, #d7ded9); border-radius: var(--radius-8, 0.5rem);
  padding: var(--space-12, 0.75rem); background: var(--color-surface-sunken, #f4f7f5); }
.my-week-availability__renewal p { margin: 0; }
.my-week-availability__renewal-heading { font-weight: 600; }
.my-week-availability__link { margin: var(--space-4, 0.25rem) 0 0;
  min-height: var(--target-size-44, 2.75rem); display: flex; align-items: center; }
`;
